module.exports = __webpack_public_path__ + "img/device_img8.310f85a4.png";